'use strict';

import React, { Component } from 'react'

import Layout   from '@Layout/BackOffice'

import DataList from '@/DataList'

import _config from '@Config/Blog/ad_blog'

import _ from 'lodash'

let config = _.cloneDeep(_config);

const app = window.app;

export default class AdminAdBlogsPage extends Component
{
	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		var output =
		(
			<Layout history={ props.history } page_title={ config.title }>

				<div className="page-content">

					<div className="o-content">
						<DataList config={ config } history={ props.history } />
					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}
